<script>
    // Import Social component
    import Social from '../ui/social.svelte';

    // Import settings
    export let infoPersonal;
</script>

<div class="bg-white p-0 py-6">
    <div class="container mx-auto">
        <div class="flex flex-col md:flex-row">
                <picture class="self-center md:w-full">
                    <source
                        srcset="{infoPersonal.image.path}_800.heic"
                        media="(min-width: 768px)"
                        type="image/heic"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_400.heic"
                        type="image/heic"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_800.jxl"
                        media="(min-width: 768px)"
                        type="image/jxl"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_400.jxl"
                        type="image/jxl"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_800.avif"
                        media="(min-width: 768px)"
                        type="image/avif"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_400.avif"
                        type="image/avif"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_800.webp"
                        media="(min-width: 768px)"
                        type="image/webp"
                    />
                    <source
                        srcset="{infoPersonal.image.path}_400.webp"
                        type="image/webp"
                    />
                    <img alt="{infoPersonal.image.name}" src="{infoPersonal.image.path}_800.jpg" />
                </picture>
                <div class="md:py-10 md:flex md:flex-col">
                    <div class="py-4 md:py-10 px-6 text-zinc-900 text-xl text-justify md:basis-10/12">{@html infoPersonal.description}</div>
                    <Social social={infoPersonal.social}/>
                </div>
        </div>
    </div>
</div>
